module.exports = __webpack_public_path__ + "img/TRANSITIONS-XTRACTIVE-5.04056711.gif";